var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('b-card',{staticClass:"text-center",attrs:{"no-body":"","id":"card"}},_vm._l((_vm.filteredQuestList),function(question ){return _c('QuestionComponent',{key:question.question_id,attrs:{"keyId":question.question_id,"question":question}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }